import Products from "@/components/Products/Products"
import Toolbar from "@/components/Toolbar/Toolbar"
import BottomToolbar from "@/components/BottomToolbar/BottomToolbar"
import { ContentChildrenProps, wrapContent } from "@/components/ContentWrapper/ContentWrapper"
import { InfiniteScroll } from "@nosto/search-js/preact/common"
import { useProductFilters } from "@nosto/search-js/preact/hooks"
import NoResults from "@/components/NoResults/NoResults"
import AppliedFiltersBar from "@/components/SelectedFilters/AppliedFiltersBar"
import { infiniteScroll } from "@/config"

// When the result set is empty *but the user got there by applying filters*,
// keep the toolbar + applied-filter bar mounted so the user can step back out
// of the empty state. On a genuinely empty collection
// (no filters applied) we still show only `<NoResults />` so the empty page
// stays clean.
function NoResultsView() {
  const { filters } = useProductFilters()
  const hasFilters = filters.length > 0
  return (
    <>
      {hasFilters && (
        <>
          <Toolbar />
          <AppliedFiltersBar />
        </>
      )}
      <NoResults />
    </>
  )
}

export function CategoryBody({ foundProducts, loading }: ContentChildrenProps) {
  if (!foundProducts && !loading) return <NoResultsView />
  return (
    <>
      <Toolbar />
      <AppliedFiltersBar />
      <Products />
      <BottomToolbar />
    </>
  )
}

export function CategoryBodyInfiniteScroll({ foundProducts, loading }: ContentChildrenProps) {
  if (!foundProducts && !loading) return <NoResultsView />
  return (
    <>
      <Toolbar />
      <AppliedFiltersBar />
      <InfiniteScroll
        observerOptions={{
          rootMargin: "50% 0px"
        }}
      >
        <Products />
      </InfiniteScroll>
    </>
  )
}

const Component = infiniteScroll ? CategoryBodyInfiniteScroll : CategoryBody
export default wrapContent("category", Component)
